export const carrier = [
	{
		key: '100062',
		name: 'Yamato(JP)',
		value: 'Yamato',
		rule: '^2994\\d{8}$'
	},
	{
		key: '100040',
		name: 'Sagawa(JP)',
		value: 'Sagawa',
		rule: '^355\\d{9}'
	},
	{
		key: '190405',
		rule: '^FLY[0-9A-Z]{9,12}$',
		ruleDesc: 'FLY## *** *** *** * YQ',
		value: 'YIHAO',
		name: '壹号专线'
	},
	{
		key: '190340',
		rule: '^XYY[0-9A-Z]{9,14}$',
		value: 'XYY',
		name: '行运易'
	},
	{
		key: '190987',
		rule: '',
		value: 'YYTT6',
		name: '顺仓科技'
	},
	{
		key: '14061',
		rule: '',
		value: 'NZ_POST',
		name: 'New Zealand Post'
	},
	{
		key: '100001',
		rule: '^\\d{10,11}$',
		value: 'DHL',
		name: 'DHL'
	},
	{
		key: '100044',
		rule: '^MP[0-9]{10}$',
		value: 'Aramex_AU',
		name: 'Aramex AU'
	},
	{
		key: '07041',
		rule: '^0034\\d{16}$',
		value: 'DHL Paket',
		name: 'DHL_Paket'
	},
	{
		key: '100002',
		rule:
			'\\b(1Z ?[0-9A-Z]{3} ?[0-9A-Z]{3} ?[0-9A-Z]{2} ?[0-9A-Z]{4} ?[0-9A-Z]{3} ?[0-9A-Z]|[\\dT]\\d\\d\\d ?\\d\\d\\d\\d ?\\d\\d\\d)\\b',
		name: 'UPS',
		value: 'UPS'
	},
	{
		key: '21051',
		name: 'USPS',
		value: 'USPS',
		rule: '^(420|94001|94055|92|93)\\d+',
		ruleDesc:
			'A# *** *** *** US,C# *** *** *** US,D# *** *** *** US,E# *** *** *** US,G# *** *** *** US,H# *** *** *** US,L# *** *** *** US,R# *** *** *** US,S# *** *** *** US,T# *** *** *** US,U# *** *** *** US,V# *** *** *** US,82 *** *** **,83 *** *** **,M4 *** *** **,V0 *** *** **,CH00 *** *** *,LH00 *** *** *,94001 *** *** *** *** *** **,94055 *** *** *** *** *** **,92 *** *** *** *** *** *** *** ***,93 *** *** *** *** *** *** *** ***,420 *** *** *** *** *** *** *** *** ***,420 *** *** *** *** *** *** *** *** *** *** *,E1905 *** * !*** **** *** *** *** *** *** *** * **,E1906 *** * !*** **** *** *** *** *** *** *** * **,L1905 *** * !*** **** *** *** *** *** *** *** * **,L1906 *** * !*** **** *** *** *** *** *** *** * **'
	},
	{
		key: '03011',
		name: 'China Post',
		value: 'CHINA_POST',
		rule: '(^[ABCEFLPRSUV].*CN$)|(^ZC[0-9]{11}$)|(^ZS[0-9]{11}$)'
	},
	{
		key: '03013',
		name: 'China EMS',
		value: 'CHINA_EMS',
		rule: '^[K].*CN$'
	},
	{
		key: '01151',
		name: 'Australia Post',
		value: 'AUSTRALIA_POST',
		rule: '^(33|34|36)[0-9A-Z]{21}$'
	},
	{
		key: '190112',
		name: 'UBI',
		value: 'UBI'
		// rule: '^400631\\d{10}$',
	},
	{
		key: '03041',
		name: 'Canada POST',
		value: 'CANADA_POST',
		rule: '^\\d{16}$'
	},
	{
		key: '190380',
		name: '六脉小包',
		value: 'LIUMAI',
		rule: '^LM\\d{10}'
	},
	{
		key: '11031',
		name: 'Royal Mail',
		value: 'ROYAL_MAIL',
		rule: '^[ABCFGJKLMNIOPQRSTUVWXYZ]{2}\\d{9}GB'
	},
	{
		key: '190094',
		name: '4PX',
		value: '4PX',
		rule: '^4PX\\d{13}[A-Z]{2}'
	},
	{
		key: '190094',
		name: 'Hermes(DE)',
		value: 'Hermes(DE)',
		rule: '^H10[012]\\d{16}$'
	},
	{
		key: '100018',
		name: 'Hermes',
		value: 'Hermes',
		rule: '^T01[A-Z0-9]{3}\\d{10}$'
	},
	{
		key: '06051',
		name: 'La Poste(FR)',
		value: 'LA_POSTE',
		rule: '^(6A|6G|LP)[0-9A-Z]{11}$'
	},
	{
		key: '100007',
		name: 'DPD(DE)',
		value: 'DPD_DE',
		rule: '^0\\d{13}$'
	},
	{
		key: '100010',
		name: 'DPD (UK)',
		value: 'DPD (UK)',
		rule: '^155\\d{11}$'
	},
	{
		key: '09071',
		name: 'Poste Italiane',
		value: 'POSTE_ITALIANE',
		rule: '^(9C|5P)[0-9A-Z]{11}$'
	},
	{
		key: '190094',
		name: 'GLS Spain(ES)',
		value: 'GLS_SPAIN',
		rule: '^618\\d{11}$'
	},
	{
		key: '14044',
		name: 'PostNL',
		value: 'PostNL',
		rule: '^LS\\d{9}NL$'
	},
	{
		key: '100017',
		name: 'Yodel',
		value: 'YODEL',
		rule: '^(JD|JJD)\\d{16}$'
	},
	{
		key: '190008',
		name: 'YunExpress',
		value: 'YUN_EXPRESS',
		rule: '^YT\\d{16}$'
	},
	{
		key: '190491',
		name: 'MoreLink',
		value: 'MORELINK',
		rule: '(^(81|91|41)\\d{13}$)|(^DH\\d{12}$)'
	},
	{
		key: '190208',
		name: 'CNE递一物流',
		value: 'CNE',
		rule: '(^DY)|(^3A5V)\\d{8,}$'
	},
	{
		key: '1000000',
		name: '韬博',
		value: 'TOPEST',
		rule: '^R60087\\d{10}$'
	},
	{
		key: '100331',
		name: 'Evri',
		value: 'Evri',
		rule: '^H\\d{2,3}[A-Z0-9]{2,3}\\d{10}$'
	},
	{
		key: '100030',
		name: 'CDEK',
		value: 'CDEK',
		rule: ''
	},
	{
		key: '19181',
		name: 'Correos Spain',
		value: 'CORREOS_SPAIN',
		rule: '^PQ56GB\\d{16}[A-Z]{1}'
	},
	{
		key: '100300',
		name: 'GLOBALTRANS',
		value: 'GLOBALTRANS',
		rule: '^GBT\\d+'
	},
	{
		key: '7044',
		name: 'Deutsche Post Mail',
		value: 'DEUTSCHE_POST',
		rule: '^(LY)[0-9]{9}DE$'
	},
	{
		key: '14061',
		name: 'New Zealand Post',
		value: 'NEW_ZEALAND_POST',
		rule: '^007942\\d{14}'
	},
	{
		key: '100295',
		name: '极兔国际',
		value: 'JT',
		rule: '^(8216|6406|YL13)\\d{8}$'
	},
	{
		key: '100003',
		rule: '(\\b96\\d{20}\\b)|(\\b\\d{15}\\b)|(\\b\\d{12}\\b)',
		name: 'Fedex',
		value: 'FEDEX'
	},
	{
		key: '2151',
		name: 'Correios Brazil',
		value: 'CORREIOS_BRAZIL',
		rule: '^NL[0-9]{9}BR$'
	},
	{
		key: '100043',
		name: 'InPost (PL)',
		value: 'IN_POST_PL',
		rule: '^520[0-9]{21}'
	},
	{
		key: '190074',
		name: '通邮集团',
		value: 'TopYou',
		rule: '^TYZRB[0-9A-Z]{12}'
	},
	{
		key: '190658',
		name: '嘀嗒国际物流',
		value: 'DIDA_LOGISTICS',
		rule: '^1[0-9]{18}'
	},
	{
		key: '100434',
		name: 'Asigna',
		value: 'ASIGNA',
		rule: '^LH[0-9]{11}ES$'
	},
	{
		key: '190086',
		name: 'Wanb Express',
		value: 'WANB_EXPRESS',
		rule: '^WNB[0-9A-Z]{12}YQ$'
	},
	{
		key: '190164',
		name: 'FEIA',
		value: 'FEIA',
		rule: '^FEI[0-9A-Z]{12}YQ$'
	},
	{
		key: '100005',
		name: 'GLS',
		value: 'GLS',
		rule: '^ZWL[0-9A-Z]{5}'
	},
	{
		key: '7048',
		name: 'DHL eCommerce Asia',
		value: 'DHL_ECOMMERCE_ASIA',
		rule: ''
	},
	{
		key: '100765',
		name: 'DHL eCommerce CN',
		value: 'DHL_ECOMMERCE_CN',
		rule: ''
	},
	{
		key: '7047',
		name: 'DHL eCommerce US',
		value: 'DHL_ECOMMERCE_US',
		rule: ''
	},
	{
		key: '100156',
		name: 'Grand Slam Express',
		value: 'GRAND_SLAM_EXPRESS',
		rule: ''
	},
	{
		key: '190929',
		name: 'ESD',
		value: 'ESD',
		rule: ''
	},
	{
		key: '100107',
		name: 'PFLogistics',
		value: 'PFLOGISTICS',
		rule: '^NEXAU[0-9]{10}YQ'
	},
	{
		key: '100047',
		name: 'DHL Parcel (NL)',
		value: 'DHL_PARCEL_NL',
		rule: '^JVGL[0-9]{20}'
	},
	{
		key: '100114',
		name: 'CTT Express',
		value: 'CTT_EXPRESS',
		rule: '^0078\\d{18}$'
	},
	{
		key: '190890',
		name: '万运通',
		value: 'WYT_EXPRESS',
		rule: '^WYT\\d{10}$'
	},
	{
		key: '100027',
		name: 'Colis Prive(Colis Privé)',
		value: 'Colis Prive(Colis Privé)',
		rule: '/^Pd{16}$/'
	},
	{
		key: '191304',
		rule: '^UD[0-9]{11}AU$',
		value: 'UDEL (AU)',
		name: 'UDEL (AU)'
	},
	{
		key: '191039',
		rule: '^UD[0-9]{11}US$',
		value: '优递',
		name: '优递'
	},
	{
		key: '191376',
		rule: '^3PE\\d{13}$',
		value: '3PE EXPRESS',
		name: '3PE EXPRESS'
	},
	{
		key: '191422',
		rule: '^ONE[0-9]{11}US$',
		value: 'QUICK_DASH',
		name: 'QUICK DASH'
	},
	{
		key: '191139',
		rule: '^EM[0-9]{12}CA$',
		value: 'Emile Corp',
		name: '亿迈尔'
	},
	{
		key: '100042',
		rule: '^(?:XOL[0-9]{9}|\\d{12}|\\d{10}|\\d{9})$',
		value: 'Purolator',
		name: 'Purolator'
	},
	{
		key: '190120',
		rule: '^JCY.*',
		value: 'JCEX',
		name: '佳成国际'
	},
	{
		key: '100555',
		rule: '^SPRINGAS[0-9]{10}$',
		value: 'Intelcom (CA)',
		name: 'Intelcom (CA)'
	},
	{
		key: '100134',
		rule: '^GV[A-Z0-9]{16}$',
		value: 'UniUni',
		name: 'UniUni'
	},
	{
        key: '101228',
        rule: '^SWX[0-9]{19}$',
        value: 'SwiftX',
        name: 'SwiftX',
    },
    {
        key: '190844',
        rule: '^SPX[A-Z0-9]+$',
        value: 'SpeedX',
        name: 'SpeedX',
    },
]
export const carrier_cn = [
	{ key: '190766', value: 'SHUNFENG', name: '顺丰速运', rule: '' },
	{ key: '190157', value: 'YTO', name: '圆通快递', rule: '^YT\\d{13}$' },
	{ value: 'ZTO', name: '中通快递', rule: '' },
	{ value: 'DPK', name: '德邦快递', rule: '' },
	{ value: 'HUOLALA', name: '货拉拉', rule: '' },
	{ value: 'SUHUI', name: '速惠物流', rule: '' }
]
export const carrierMatch = (code: string): any => {
	if (!code) return null
	for (const item of [...carrier, ...carrier_cn]) {
		if (!item.rule) continue
		const regex = new RegExp(item.rule)
		const isMatch = regex.test(code)
		if (isMatch) {
			return {
				name: item.name,
				value: item.value
			}
		}
	}
	return null
}

export const carrierNameMatchByKey = (key: string): any => {
	if (!key) return null
	for (const item of carrier) {
		if (!item.key) continue
		if (item.key == key) {
			return item.name
		}
	}
	return null
}
